import { Component, OnInit, Output, EventEmitter, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NbDialogService } from '@nebular/theme';
import { CookieService } from 'ngx-cookie-service';
import { TranslationService } from '../../language/translation.service';

import * as _ from 'lodash';

@Component({
  selector: 'app-select-single-product',
  templateUrl: './select-single-product.component.html',
  styleUrls: ['./select-single-product.component.scss']
})
export class SelectSingleProductComponent implements OnInit {
  @Output() emitClose = new EventEmitter();
  @Output() emitList = new EventEmitter();
  @Input() orgData: Array<any>;  //已選資料_來源
  @Input() info: {
    IsLoding: boolean
    ORG_Store_ID: string,
    PRD_PlatformType_ID: number,
    EditDisposablesMo: any,
  };

  //---------"與父組件共用，不可改位址------->---------------------
  @Input() ProductList: Array<any>;  //商品清單

  //-----------------------談窗----------------------------

  modalRef = null;  //談窗鉤子
  PdModalRef = null;  //談窗鉤子

  @ViewChild('Modal') Modal: TemplateRef<any>
  @ViewChild('PdModal') PdModal: TemplateRef<any>

  //--------------------------------------------------------
  //資料清單
  selectData: Array<any>;//已選資料
  mainDataList: Array<any>; //顯示資料  
  showList: Array<any>;     //群組顯示資料 
  showListPd: Array<any>;   //商品顯示資料 
  query = {  //查詢選項
    searchKey: "",
    ORG_Company_ID: null,
    ORG_Store_ID: null,
  }
  status = { //當前狀態
    isSelectAll: false, //是否已全選
    AllSelectCount: 0, //當前已選總數量
    showType: null // 顯示有選過的
  }


  //查詢的門市
  storeSelectList: selectData[];
  selectORG_Store_ID: number;
  PRD_PlatformType_ID: number;

  constructor(
    private dialogService: NbDialogService,
    private http: HttpClient,
    private cookieService: CookieService,
    private translationService: TranslationService,

  ) {
    let cookie_sid = this.cookieService.get('ORG_Store_ID')
    this.query.ORG_Store_ID = (cookie_sid && cookie_sid != '') ? parseInt(cookie_sid) : null
    this.query.ORG_Company_ID = parseInt(this.cookieService.get('ORG_Company_ID'))
  }

  //info 資料來源 = callAPI / 外部丟入
  //data 來源 =  MainData[ListName]

  //全選功能:
  // 撈取全部資料以提供全選 -  那麼分頁將不再重要 : 建議改成設定欄位
  // 全選讀取設定，非全選讀取陣列 
  // 同上問題，在經過搜尋之後的全選將有所刪減，因此除了"全選設定欄位"，還要加上查詢欄位，在後端進行查詢
  // 同上問題，過程中的其他方的新增，可能導致有額外資料產生。
  // 但不管是丟設定到後端查後取資，一開始取全資但顯示還是每頁只抓當頁資料，都可能造成以上問題。
  // 因此最佳處理還是一開始就丟出全部到前端顯示。 但如此行為可能導致效能緩慢? 
  // 單頁全選-可以正常運作

  ngOnInit(): void {


  }

  ngAfterViewInit() {
    this.onOpen(this.info, this.orgData)
  }

  t(key: string, fallback: string): string {
    const text = this.translationService.getText(key);
    return !text || text === key ? fallback : text;
  }


  //取得門市清單 API
  getStoreList(fun) {//取得門市清單 USP_YOPOSWebGetStoreList

    this.http.post<any>('api/ORGStore/StoreList', {

      ORG_Company_ID: this.query.ORG_Company_ID,
      ORG_Store_ID: this.query.ORG_Store_ID,
    }).subscribe({
      next: data => {

        this.storeSelectList = [];


        //門市共用下拉選單
        let Item: any = {};
        Item.value = 0;
        Item.content = '總部';
        this.storeSelectList.push(Item);

        if (this.query.ORG_Store_ID) {

          //門市共用下拉選單
          let Item: any = {};
          Item.value = this.query.ORG_Store_ID;
          Item.content = data.LIST.find(x => x.ORG_Store_ID == this.query.ORG_Store_ID).StoreName;
          this.storeSelectList.push(Item);

        } else {

          data.LIST.forEach(element => {
            //門市共用下拉選單
            var selectItem = new selectData();
            selectItem.value = element.ORG_Store_ID;
            selectItem.content = element.StoreName;
            this.storeSelectList.push(selectItem);
          });


        }
        // 預設點第一個
        if (this.storeSelectList.length > 0) {
            this.selectORG_Store_ID = this.storeSelectList[0].value
        }

        if(fun)
          fun()
      },
      error: error => {
        console.error('There was an error!', error);
      }
    });

  }


 //開啟
  onOpen(info, useData) {
    

    if (info){
      this.info = info
      this.PRD_PlatformType_ID = this.info.PRD_PlatformType_ID
    }
      

    this.mainDataList = []
    this.selectData = []

    //存下已選資料
    if(useData && useData.length){
      this.selectData =  _.cloneDeep(useData) 
    }

    //api抓資料
    this.getStoreList(()=>{
      this.getProductList((data) => {
        this.showData(data, useData)  
      })  
    })
   
       

    //開啟談窗
    this.modalRef = this.dialogService.open(this.Modal, {})
    this.modalRef.onClose.subscribe(result => {
      this.emitClose.emit(true);
    });
  }


  // 組資料
  showData(data, useData) {
    var all = []
    if (this.info.EditDisposablesMo != null){
      this.info.EditDisposablesMo.disposablesRuleReqs.forEach(k => {
        if (k.PRDProductNo){
          if (useData != null && useData.length > 0){
            if (useData[0].No != k.PRDProductNo){
              all.push(k.PRDProductNo)
            }
          }else{
            all.push(k.PRDProductNo)
          }
        }
       
      });
    }
    
   


    //組合內容
    let ProductList = [];
    let list = _.groupBy(data.LIST, 'GroupNo');
    let key = _.keys(list)
    key.forEach(k => {
      let obj = new ProductGroup()
      obj.CreateStoreName = list[k][0].CreateStoreName
      obj.GroupNo = k,
        obj.GroupName = list[k][0].GroupName,
        obj.PDList = _.concat([], list[k]),  //TODO 位址有更新嗎?存疑
        obj.PDList = obj.PDList.filter(item => !all.includes(item.No)),
        obj.IsOK_Group = false
        if (obj.PDList != null && obj.PDList.length > 0) {
          ProductList.push(obj)
        }
    });

    console.log('....')
    this.mainDataList = ProductList


    //判斷是否已勾選
    if (useData) {
      this.mainDataList.forEach(g => {
        g.PDList.forEach(p => {
          let pd = _.find(useData, a => a.No == p.No)
          if (pd) {
            pd.GroupNo = p.GroupNo;
            p = _.assign(p, pd)
            p.IsOK_Product = true
            g.IsOK_Group = p.IsOK_Product
          }


        })

        g.IsOK_Product_Count()
        this.sumSelect()
      })

    }

    // //合併到原始資料
    // if (!this.orgData || !this.orgData.length) {
    //   this.orgData = _.cloneDeep(this.mainDataList)
    // }


  }


  //查詢
  onQuery() {
    this.getProductList((data) => {
      let useData = []
      
      // this.mainDataList.forEach(x => {
      //   x.PDList.forEach(y => {
      //     if (y.IsOK_Product)
      //       useData.push({ GroupNo: y.GroupNo, No: y.No })
      //   })
      // })

      this.selectData.forEach(y => {
          useData.push({ GroupNo: y.GroupNo, No: y.No })
      })

      this.showData(data, useData)

    })

  }

  //加入已選商品
  AddSelectData(pd,isSelect){
    if(isSelect){
      if(!_.find(this.selectData,a=>a.No==pd.No)){
        this.selectData.push(pd)
      }
    }else{
      _.remove(this.selectData,x=>x.No==pd.No)
    }
  }
  //統計已選數量
  sumSelect() {
    let selectCount = 0
    let allcount = 0
    this.mainDataList.forEach(group => {
      selectCount += group.CountSum
      allcount += group.PDList.length
    })

    this.status.AllSelectCount = selectCount
    this.status.isSelectAll = (selectCount == allcount)

  }

  

  //權限模組的開關
  checkModuleValue(data: any) {
    var IsOK_Product = data.IsOK_Product
    this.mainDataList.forEach(g => {
      g.PDList.forEach(p => {
        if (p.IsOK_Product){
          p.IsOK_Product = false
          this.AddSelectData(p,p.IsOK_Product)
        }
      })
      g.IsOK_Product_Count()
      this.sumSelect()
    })


    this.showListPd.forEach(p => {
      p.IsOK_Product = false
    })
    this.sumSelect()
    data.IsOK_Product = IsOK_Product

  }



  //處存商品群組  最終存檔!!
  onSavePdG() {
    if (this.selectData) {
      this.selectData.forEach(x => {
        x.Sorting = 0
      })
    }

    this.emitList.emit(this.selectData)
    this.modalRef.close()
  }




  //商品 打開彈窗
  onOpenPd(GID) {
    let group = _.find(this.mainDataList, a => a.GroupNo == GID)
    this.showListPd = _.cloneDeep(group.PDList)

    //開啟談窗
    this.PdModalRef = this.dialogService.open(this.PdModal, {})
  }

  //商品 處存
  onSavePd() {
    let GID = this.showListPd[0].GroupNo
    let group = _.find(this.mainDataList, a => a.GroupNo == GID)
    console.error(GID);
    console.error(this.mainDataList);
    console.error(group);
    console.error(this.showListPd);
    _.assign(group.PDList, this.showListPd)
    group.IsOK_Group = _.findIndex(group.PDList, 'IsOK_Product') > -1
    group.IsOK_Product_Count()

    if(group.PDList){
      group.PDList.forEach(x=>{
        this.AddSelectData(x,x.IsOK_Product)
      })
    }




    this.sumSelect()


    this.PdModalRef.close()
  }






  //取得可用商品資料
  getProductList(fun) {
    this.info.IsLoding = true
    this.http.get<any>(`api/ProductSetting/GetAllProductList?` +
      `ORG_Company_ID=${this.query.ORG_Company_ID}` +
      `${this.selectORG_Store_ID != null ? "&CreateStore=" + this.selectORG_Store_ID : ''}` +
      `&Keyword=${this.query.searchKey}` +
      `${this.PRD_PlatformType_ID != null ? "&PRD_PlatformType_ID=" + this.PRD_PlatformType_ID : ''}`
    ).subscribe({
      next: data => {
      
        this.info.IsLoding = false

        if (fun)
          fun(data)

        

      },
      error: error => {
        console.error('There was an error!', error);
        this.info.IsLoding = false

      }
    });
  }


}

class ProductGroup {
  CreateStoreName: string
  GroupNo: string;
  GroupName: string;
  IsOK_Group: boolean;
  PDList: Product[];
  CountStr: string;
  CountSum: number;
  IsOK_Product_Count() {
    // console.log('go')
    let use = _.filter(this.PDList, 'IsOK_Product').length
    this.CountStr = use == this.PDList.length ? '已全選' : `已選${use}項`
    this.CountSum = use
  }

}

class Product {
  GroupNo: string;
  GroupName: string;
  No: string;
  Name: string;

  IsOK_Group: boolean;
  IsOK_Product: boolean;
}


class selectData {
  value: number;//
  content: string;//
  info: string
}

